module.exports = __webpack_public_path__ + "img/p2-2-2.856bb920.png";